import apiClient from "../../../../../../services/apiClient";

export const getAttendanceData = async (idKg, idGr, date, period) => {
  const linkPost = `tabel_group/perchild/${idKg}/${idGr}`;
  const body = { date, period };
  
  try {
    const response = await apiClient.post(linkPost, body);
    return response;
  } catch (error) {
    throw new Error(`Error getting attendance data: ${error}`);
  }
};

export const getChildrenInfo = async (idKg, idGroup, dateTo, period) => {
  const linkPost = `kindergartens/${idKg}/children/main_info?groups=${idGroup}&date_to=${dateTo}&period=${period}`;
  
  try {
    const response = await apiClient.get(linkPost);
    return response;
  } catch (error) {
    throw new Error(`Error getting children info: ${error}`);
  }
};

export const saveAttendance = async (attendanceData) => {
  const { idKg, idGr } = attendanceData;
  const linkPost = `tabel_group/${idKg}/${idGr}`;
  
  try {
    const response = await apiClient.post(linkPost, attendanceData);
    return response;
  } catch (error) {
    throw new Error(`Error saving attendance: ${error}`);
  }
};

export const saveTempAttendance = async (attendanceData) => {
  const { idKg, idGr } = attendanceData;
  const linkPost = `tabel_group_temp/${idKg}/${idGr}`;
  
  try {
    const response = await apiClient.post(linkPost, attendanceData);
    return response;
  } catch (error) {
    throw new Error(`Error saving temporary attendance: ${error}`);
  }
};